export default function(ob) {
  return JSON.parse(JSON.stringify(ob));
}
